import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Course from "@/pages/Course";
import MentorPage from "@/pages/MentorPage";
import PackagesPage from "@/pages/PackagesPage";
import ResourcesPage from "@/pages/ResourcesPage";
import Contact from "@/pages/Contact";
import Decide from "@/pages/Decide";
import Batches from "@/pages/Batches";
import Admin from "@/pages/Admin";
import Community from "@/pages/Community";
import CommunityHandbook from "@/pages/CommunityHandbook";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/course" element={<Course />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/mentor" element={<MentorPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/decide" element={<Decide />} />
          <Route path="/batches" element={<Batches />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/handbook" element={<CommunityHandbook />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#F4F3ED",
            border: "1px solid #2A2A2A",
            borderRadius: 0,
            fontFamily: "Satoshi, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
